import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "colorTShirt.icon-a31144",
  "use": "colorTShirt.icon-a31144-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"colorTShirt.icon-a31144\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.4574 6C23.6374 7.23047 21.9592 8.08374 20 8.08374C18.0408 8.08374 16.3626 7.23047 15.5426 6L5 10.3671L7.87018 19.125L11.25 17.725V33.5H28.75V17.725L32.1298 19.125L35 10.3671L24.4574 6Z\" fill=\"#C0392B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol